var exports = {
  "Y": "xcc377c0b--00f54c--tooltip",
};

module.exports = exports;
